import axios from "axios"

export const submitCatalogDownloadEmail = (email: string) =>
  axios.post("/.netlify/functions/catalogDownloadEmail", { email })
